import styles from './ForOrganizers.module.css';
import toutes from '../assets/toutes_white.png';
import newsletter from '../assets/send_white.png';
import heart from '../assets/heart.png';
import instagram from '../assets/instagram.png';
import plusBtn from '../assets/plusBtn.png';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function ForOrganizers() {

    const title = "Pour les organisateurs d’événements à Québec | alentours";
    const description = "Tu organises des événements à Québec ? Alentours est une plateforme locale indépendante qui recense et met en valeur les événements culturels et communautaires.";

    return <div className={[styles.page, styles.organizers].join(' ')}>
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={location.href} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
        </Helmet>
        <section className={styles.hero}>
            <h1>Tu organises des événements à Québec ?</h1>
            <p>On t'aide à les rendre visibles.
                alentours est une plateforme locale indépendante qui recense et met en valeur les événements culturels, musicaux et communautaires à Québec et dans les environs.
            </p>
        </section>
        <br />
        <section>
            <Link className={styles.createEvent} to="/nouveau">
                <img src={plusBtn} alt="" aria-hidden="true" width="25" height="25" />
                <span>Crée ton événement ici, c'est gratuit!</span>
            </Link>
        </section>
        <br />
        <section>
            <h2>Chaque semaine</h2>
            <ul>
                <li>On recense les événements à venir dans la région</li>

                <li>On sélectionne des événements coups de cœur</li>

                <li>On partage ces découvertes sur notre site et dans notre infolettre hebdomadaire (communauté en croissance)</li>
            </ul>
            <p>
                Notre approche est éditoriale, humaine et sélective : on privilégie la pertinence et la qualité plutôt que la quantité.
            </p>
        </section>
        <section className={styles.whySection}>
            <h2>Pourquoi créer mon événement sur alentours?</h2>
            <div className={styles.benefitGrid}>
                <article>
                    <h3>Visibilité</h3>
                    <p>Chaque semaine, des milliers de personnes qui se demandent quoi faire à Québec consultent notre plateforme à la recherche d’idées d’activités et de sorties.</p>
                </article>
                <article>
                    <h3>Prêt pour l’intelligence artificielle</h3>
                    <p>De plus en plus de personnes demandent à des assistants comme ChatGPT, Gemini ou Claude de leur suggérer des activités à proximité. En publiant votre événement sur alentours, vous rendez ses informations accessibles aux visiteurs, aux moteurs de recherche et aux outils d’intelligence artificielle.</p>
                    <p className={styles.proofNote}>Alentours est déjà cité plus de 3 000 fois par mois dans les réponses d’IA mesurées par Bing Webmaster Tools.</p>
                </article>
            </div>
        </section>
        <hr />
        <section>
            <h2>Comment ton événement peut être mis en valeur</h2>
            <p>

                Selon le format et la pertinence, un événement peut bénéficier de :
            </p>
            <div className={styles.grid}>
                <div><img src={toutes} alt="calendrier" /> un meilleur placement sur notre site</div>

                <div><img src={heart} alt="heart" />une mise en avant comme événement coup de cœur</div>

                <div><img src={newsletter} alt="infolettre" />une mention dans notre infolettre hebdomadaire</div>

                <div><img src={instagram} alt="instagram" />une mention sur nos réseaux sociaux</div>
            </div>
            <br /><br />

        </section>
        <section>
                
           
        
        </section>
        <section className={styles.contact}>

            <Link className={styles.button} to="/promouvoir-un-evenement">
                En savoir plus sur la promotion
            </Link>

        </section>
        <br /><br /><br />
    </div>;
};
